import { AbstractHTMLHelp } from "@lib/titan2/dist/game/view/display/AbstractHTMLHelp";
import { Dictionary } from "@lib/titan2/dist/util/collection/Dictionary";
import { CurrencyUtil } from "@lib/titan2/dist/util/currency/CurrencyUtil";
/**
 * SlingoHTMLHelp.ts
 */
export class SlingoHTMLHelp extends AbstractHTMLHelp {
    open() {
        super.open();
        this.handleSuperSpin();
    }
    createParams() {
        this.params = new Dictionary();
        this.params.setValue("{Game.stake}", this.model.getStake().getCurrent.bind(this.model.getStake()));
        this.params.setValue("{param.game}", "Slingo");
        this.params.setValue("{param.amount}", this.factory.getWrapperConfig().getOperatorConfig().getAutoCompleteInterval());
        this.params.setValue("{game.initial.spins.param.amount}", this.model.getGameConfig().getNumberOfSpins.bind(this.model.getGameConfig()));
        const maxStake = this.model.getStake()?.getMaximumPurchaseStake();
        if (maxStake) {
            this.params.setValue("{param.maxSpinPrice}", CurrencyUtil.format(maxStake));
        }
        this.params.setValue("{param.maxSuperWheelSpins}", this.model.getGameConfig().getMaximumStakeToSpinAttempts());
    }
    addImages() {
        this.addColumn("help.slingo.standard.main.main", [this.createImage("Game-Landscape-Logo.webp")], "15em");
        this.addColumn("help.slingo.standard.board.title", [this.createImage("Game-HelpPageWinLines.webp")], "15em");
        this.addColumn("help.slingo.standard.wild.title", [this.createImage("Game-ReelSymbolJ.webp")], "15em");
        this.addColumn("help.slingo.standard.superwild.title", [this.createImage("Game-ReelSymbolSJ.webp")], "15em");
        this.addColumn("help.slingo.standard.freespin.title", [this.createImage("Game-ReelSymbolFS.webp")], "15em");
    }
    handleSuperSpin() {
        if (!this.model.hasStakeToSpin()) {
            this.filterElementsById(this.uiProperties.superSpinWheelElements);
        }
        if (!this.model.getMaximumStakeToSpinAttempts()) {
            this.filterElementsById(this.uiProperties.superSpinWheelMaxSpinElements);
        }
    }
}
//# sourceMappingURL=SlingoHTMLHelp.js.map